import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { submitScreenshots } from 'services/user';
import { getBase64Screenshot } from 'utils/utils';

const StatusXXPage: FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(async () => {
      const screenshotParamsStr = sessionStorage.getItem('bookStatusXX');

      if (screenshotParamsStr) {
        const screenshotParams = JSON.parse(screenshotParamsStr);
        const { transactionId, orderId, url } = screenshotParams;
        const image = await getBase64Screenshot(ref.current);

        const result = await submitScreenshots(
          { screenshots: [], orderId, lastScreenshot: image, transactionId },
          url
        );

        if (result) {
          sessionStorage.removeItem('bookStatusXX');
        }
      }
    }, 1000);
  }, []);

  const { t } = useTranslation();
  return (
    <div className="expired" ref={ref}>
      <div className="title">{t('error')}</div>
      <p className="expired-content">{t('home.failed_to_pay')}</p>
      <Link to={'/'} className="btn btn-primary">
        {t('home.go_back')}
      </Link>
    </div>
  );
};

export default StatusXXPage;
